<template>
    <div>
        <home></home>
        <div class="pagerc">
            <div class="headerimg">
                <img class="pcshow" src="../assets/images/info.jpg" alt="">
                <img class="mshow" src="../assets/images/minfo.png" alt="">
                <div class="title">
                    <div class="titlep">
                        <h3>大会信息</h3>
                        <h4>MEETING INFORMATION</h4>
                    </div>
                </div>
            </div>
            <div class="inchild clear">
                <div class="wrapleft">
                    <h2>{{info.info1}}</h2>
                    <div class="wrapbox">
                        <div class="infop">
                            <p>{{info.info2}}</p>
                            <p>{{info.info3}}</p>
                            <p>{{info.info4}}</p>
                        </div>
                        <div class="wpeople">
                            <h5>适宜参加人群</h5>
                            <p>此次会议不仅是商界、学术界和政府机构人力资源领导和专家的专享盛会，更诚邀广大从事人力资源工作的专业人士参会，包括CHO、CLO、企业大学校长、HRD、HRBP、OD总监、招聘总监等。</p>
                            <p>*目前50%的与会者均是企业HRD及高管。</p>
                            <h6>时间：<span>2019 年 11.13-11.15</span></h6>
                            <h6>地点：<span>中国上海 雅居乐万豪酒店</span></h6>
                        </div>
                        <div class="cblx">
                            <div class="inlinecontact">
                                <h5>赞助联系人：</h5>
                                <ul>
                                    <li><i class="el-icon-coordinate"></i> Mag Mao</li>
                                    <li><i class="el-icon-phone-outline"></i> +86-21-6840 5597</li>
                                    <li><i class="el-icon-message"></i> mag@hrflag.com</li>
                                </ul>
                            </div>
                            <div class="inlinecontact">
                                <h5>报名联系人：</h5>
                                <ul>
                                    <li><i class="el-icon-coordinate"></i> Luffy Liu</li>
                                    <li><i class="el-icon-phone-outline"></i> +86-021-6840-3875</li>
                                    <li><i class="el-icon-message"></i> luffy@hrflag.com</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <wrapleft></wrapleft>
            </div>
        </div>
        <foots></foots>
    </div>
</template>

<script>
 import home from '@/components/commn/home'
  import foots from '@/components/commn/foots'
  import wrapleft from '@/components/commn/wrapleft'
 export default {
      components:{
        home,
        foots,
        wrapleft
      },
       metaInfo: {
            title: '全球人才评鉴高峰会-人才评鉴技术组织和个人提供交流信息和实践经验的平台',
            meta: [
            {
                name: 'keywords',
                content: '人才评鉴技术，人才评鉴，全球人才评鉴高峰会'
            },
            {
                name: 'description',
                content: '由DDI创始人兼执行董事长威廉·白翰姆（William C. Byham）博士在美国维吉尼亚州威廉斯堡市创办了首届全球人才评鉴高峰会（International Congress on Assessment Center Methods），旨在为早期使用人才评鉴技术的组织和个人提供交流信息和实践经验的平台。'
            }
            ]
        },
    data () {
        return {
            info: {
                info1: '关于【全球人才评鉴高峰会】',
                info2: '1973年，威廉·白翰姆（William C. Byham）博士在美国维吉尼亚州威廉斯堡市创办了首届全球人才评鉴高峰会（International Congress on Assessment Center Methods），旨在为早期使用人才评鉴技术的组织和个人提供交流信息和实践经验的平台。',
                info3: '四十多年来，大会始终聚焦于人才评鉴领域的学术研究、最佳实践、评鉴中心应用等方法及新技术，为促进人才评鉴的研究、发展及行业交流不遗余力，不仅持续帮助组 织公平、公正地做出招聘和晋升决策，也引导、发展并见证了近半世纪以来人才评鉴在组织人才管理中的演进与价值！',
                info4: '会议创办早期即建立了《人才评鉴指导方针》，并于2014年在美国维吉尼亚州亚历山德里亚市举办的第38届会议中更新通过了《2014年评鉴中心运营指导方针及道德规范》（The 2014 Guidelines and Ethical Considerations for Assessment Center Operations - 6th Edition）。该文件建立了人才评鉴领域中的专业及道德原则，完全反映并满足了现代组织、跨文化、科学技术及衡量标准等相关议题上的需求。（详情参见 https://www.assessmentcenters.org/articles）已成功举办41届的大会足迹遍布全球，曾在美国、加拿大、印尼、新加坡、英国、德国及南非等多地举办，与会的国际学术界、咨询界、商界以及企业人力资源领域的意见领袖和专业工作者累计达万人，演讲者超千位。',
            }
        }
    }
}
</script>

<style scoped>
    @import url('../assets/css/inpublic.css');
    body {
        color: #333333;
        font-family: '微软雅黑';
    }
    
</style>



// WEBPACK FOOTER //
// src/components/info.vue